<template>
  <div class="freight-table-routes-filters">
    <a-input-search
      v-model="searchValue"
      placeholder="Busque pela rota"
      class="freight-table-routes-filters__search"
      allow-clear
      @search="emitFilterChange"
      @change="onInputChange"
    >
      <a-icon slot="prefix" type="search" style="color: rgba(0, 0, 0, 0.25)" />
    </a-input-search>

    <a-button
      class="freight-table-routes-filters__btn"
      @click="$emit('open-filters')"
    >
      <a-icon type="control" /> Filtros
    </a-button>
  </div>
</template>

<script>
import debounce from "lodash/debounce";

export default {
  name: "FreightTableRoutesFilters",
  data() {
    return {
      searchValue: "",
    };
  },
  created() {
    this.debouncedEmit = debounce(this.emitFilterChange, 500);
  },
  beforeDestroy() {
    this.debouncedEmit.cancel();
  },
  methods: {
    onInputChange() {
      this.debouncedEmit();
    },
    emitFilterChange() {
      this.$emit("filter-change", { search: this.searchValue });
    },
  },
};
</script>

<style scoped lang="less">
@import "~@/shared/styles/variables.less";

.freight-table-routes-filters {
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;

  &__search {
    width: @details-search-width;

    /deep/ .ant-input {
      border-radius: 6px;
    }
  }

  &__btn {
    border-radius: 6px;
    height: 36px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: @color-text-medium;
  }
}
</style>
